module.exports = __webpack_public_path__ + "img/sleeve_flounce_length.6c8e6e89.png";